import React from "react";
import styled from "styled-components";
import { Modal } from "antd";
import { ICompleteQuiz, useQuizStore } from "store";
import ReportCard, { ReportCardProps } from "./ReportCard";
import { QuizIdleState } from "./IdleState";
import { QuizLoadingState } from "./LoadingState";
import { QuizActiveState, QuizActiveStateProps } from "./ActiveState";
import { QuizCompleteState } from "./CompleteState";
import { QuizPauseState } from "./PauseState";

// Styled components for the modal
const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    padding: 24px;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close {
    top: 16px;
    right: 16px;
  }
`;


export interface QuizModalProps extends Pick<ReportCardProps, "onGetQuiz"| "onGetCorrectAnswers">,
Pick<QuizActiveStateProps, "onGetQuestionAnswer"> {
  onComplete: ICompleteQuiz;
}
export const QuizModal: React.FC<QuizModalProps> = ({
  onComplete, onGetCorrectAnswers, onGetQuiz, onGetQuestionAnswer
}) => {
  const {
    isOpen, quizState, startQuiz, closeQuiz, resetQuiz,
    quizYears
  } = useQuizStore();

  

  return (
    <>
      <StyledModal
        open={isOpen}
        onCancel={closeQuiz}
        footer={null}
        width={550}
        centered
      >
        {quizState === "idle" && <QuizIdleState {...{
          availableQuizzes: quizYears,
          onStartQuiz(quizYear, quizMode) {
            startQuiz({
              quiz: quizYear,
              quizMode,
              onComplete,
            })
          },
        }}/>}
        {quizState === "loading" && <QuizLoadingState />}

        {quizState === "active" && <QuizActiveState {...{
          onGetQuestionAnswer
        }}/>}
        {quizState === "completed" && <QuizCompleteState {...{
          onShare(data) {
            
          },
        }}/>}
        {quizState === "paused" && <QuizPauseState />}
        {quizState === "reportCard" && <ReportCard {...{
          onTakeQuizAgain: resetQuiz,
          onGetQuiz,
          onGetCorrectAnswers
        }}/>}
      </StyledModal>
    </>
  );
};

export default QuizModal; 

/**
 * 2232687912 - UBA - Divine
 */